import React from 'react';

import AdelphiFieldLayout from './layout';

function AdelphiField(props) {
  return <AdelphiFieldLayout {...props} />;
}
export default AdelphiField;
